/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

const setScrollbarWidth = () => {
	const
		prevWidth = window.getComputedStyle( document.documentElement ).getPropertyValue( '--scrollbar-width' ),
		newWidth = `${ window.innerWidth - document.body.clientWidth }px`;
	if ( newWidth !== prevWidth ) {
		document.documentElement.style.setProperty( '--scrollbar-width', newWidth );
	}
};

window.addEventListener( 'load', setScrollbarWidth );
window.addEventListener( 'resize', setScrollbarWidth );

setScrollbarWidth();


$(document).ready(function() {
	// Initially hide all sections except the first one and add the 'active' class
	var allSections = $('.archive_reviews_section');
	var categoryLinks = $('.sliding-content-archive-review');

	// Initially, show the first section with fade-in and add 'active' class to the first link
	allSections.hide();
	allSections.first().fadeIn(500).addClass('active');
	categoryLinks.first().addClass('active');

	// Click event for category links
	categoryLinks.on('click', function(e) {
		e.preventDefault(); // Prevent default anchor link behavior

		var targetId = $(this).attr('href').substring(1); // Extract the ID without the #
		var targetSection = $('#' + targetId); // Get the target section using the ID

		if (targetSection.length) {

			// Remove 'active' class from all sections and links
			allSections.removeClass('active').hide();
			categoryLinks.removeClass('active');
			$('.cs-button-load-more').hide(); // Hide all "Show More" buttons

// Fade in the clicked section, add 'active' class, and show its "Show More" button
			targetSection.fadeIn(500).addClass('active');
			$(this).addClass('active');
			targetSection.find('.cs-button-load-more').show(); // Show "Show More" button for the current section


			// Ensure the first set of reviews in the target section is shown
			// targetSection.find('.review_item').slice(0, 3).fadeIn(500); // Smoothly show the first 3 reviews
		} else {
			console.error('Target section not found for ID: ' + targetId);
		}
	});

});

document.addEventListener("DOMContentLoaded", function () {
	const searchInput = document.getElementById("review-search");
	const allReviewItems = document.querySelectorAll(".review_item");
	const allSections = $('.archive_reviews_section'); // Using jQuery for sections
	const categoryLinks = $('.sliding-content-archive-review'); // Using jQuery for links
	const noResultsElement = document.querySelector(".no-results");
	const loadMoreButtons = document.querySelectorAll(".cs-button-load-more");
	const clearButton = document.querySelector(".review-search-clear");

	let reviewsPerPage = 2;
	let currentIndices = {}; // Store current index for each section

	// Initially, show the first section with fade-in and add 'active' class to the first link
	allSections.hide();
	allSections.first().fadeIn(500).addClass('active');
	categoryLinks.first().addClass('active');

	// Function to show reviews for a section
	function showReviews(section, currentIndex) {
		let reviews = section.querySelectorAll(".review_item");

		// Show the next set of reviews
		for (let i = currentIndex; i < currentIndex + reviewsPerPage && i < reviews.length; i++) {
			reviews[i].style.display = "flex";
			reviews[i].style.opacity = 0; // Start hidden
			setTimeout(() => {
				reviews[i].style.transition = "opacity 0.5s";
				reviews[i].style.opacity = 1; // Fade-in effect
			}, 0);
		}

		currentIndex += reviewsPerPage;

		// Hide the "Load More" button if all reviews are displayed
		let loadMoreButton = section.querySelector(".cs-button-load-more");
		if (currentIndex >= reviews.length) {
			loadMoreButton.style.display = "none";
		} else {
			loadMoreButton.style.display = "block";
		}

		return currentIndex; // Return updated current index
	}

	// Set up event listeners for each "Load More" button
	loadMoreButtons.forEach(function (button) {
		let section = button.closest(".archive_reviews_section");
		let sectionId = section.getAttribute('id');
		currentIndices[sectionId] = 0; // Initialize current index for this section

		// Initial load for each section
		currentIndices[sectionId] = showReviews(section, currentIndices[sectionId]);

		button.addEventListener("click", function () {
			currentIndices[sectionId] = showReviews(section, currentIndices[sectionId]);
		});
	});

	if(searchInput){
		searchInput.addEventListener("input", function () {
			const query = searchInput.value.toLowerCase().trim();
			let hasResults = false;

			allSections.each(function () {
				$(this).show(); // Ensure section is visible for search
			});

			allReviewItems.forEach(function (reviewItem) {
				const authorName = reviewItem.querySelector(".author-name").textContent.toLowerCase();
				const reviewTitle = reviewItem.querySelector(".review-title").textContent.toLowerCase();
				const reviewBody = reviewItem.querySelector(".review-body").textContent.toLowerCase();

				// Check if the query matches any of the review content
				if (authorName.includes(query) || reviewTitle.includes(query) || reviewBody.includes(query)) {
					reviewItem.style.display = "flex";
					reviewItem.style.opacity = "1";
					hasResults = true;
				} else {
					reviewItem.style.display = "none";
				}
			});

			// Show or hide the "no results" message
			if (query.length > 0 && !hasResults) {
				noResultsElement.style.display = "block";
			} else {
				noResultsElement.style.display = "none";
			}

			// Hide all "Show More" buttons during the search
			loadMoreButtons.forEach(function (button) {
				button.style.display = "none";
			});
		});
	}


	// clearButton.addEventListener("click", function () {
	// 	// Clear the search input field
	// 	searchInput.value = "";
	//
	// 	// Reset the review items visibility
	// 	allReviewItems.forEach(function (reviewItem) {
	// 		reviewItem.style.display = "flex";
	// 		reviewItem.style.opacity = "1";
	// 	});
	//
	// 	// Hide the "no results" message
	// 	noResultsElement.style.display = "none";
	//
	// 	// Show all "Show More" buttons
	// 	loadMoreButtons.forEach(function (button) {
	// 		button.style.display = "block";
	// 	});
	//
	// 	// Reset the sections to initial state
	// 	allSections.hide().removeClass('active');
	// 	allSections.first().fadeIn(500).addClass('active');
	//
	// 	// Reset the category links to initial state
	// 	categoryLinks.removeClass('active');
	// 	categoryLinks.first().addClass('active');
	//
	// 	// Reset current indices for each section and show initial reviews
	// 	loadMoreButtons.forEach(function (button) {
	// 		let section = button.closest(".archive_reviews_section");
	// 		let sectionId = section.getAttribute('id');
	// 		currentIndices[sectionId] = 0; // Reset index
	// 		currentIndices[sectionId] = showReviews(section, currentIndices[sectionId]); // Show initial reviews again
	// 	});
	// });

	if(clearButton){
		clearButton.addEventListener("click", function () {
			// Reload the page
			window.location.reload();

			// After reloading, scroll to the element with id "review-search"
			window.onload = function () {
				document.getElementById("review-search").scrollIntoView({ behavior: "smooth" });
			};
		});
	}


});

$(document).ready(function() {
	// Define scroll offsets for desktop and mobile
	const desktopOffset = 310;
	const mobileOffset = 200;

	// Determine the appropriate offset based on the screen width
	const scrollOffset = window.innerWidth <= 768 ? mobileOffset : desktopOffset;

	// Select all anchor links with a hash in the href
	$('a[href*="#"]').on('click', function(event) {
		// Get the full URL of the current page
		const currentPageUrl = window.location.href.split('#')[0];

		// Get the URL from the clicked link, excluding the hash part
		const linkUrl = $(this).attr('href').split('#')[0];

		// If the link points to the same page, apply smooth scrolling
		if (currentPageUrl === linkUrl || linkUrl === "") {
			event.preventDefault(); // Prevent the default jump behavior

			// Get the target ID from the href attribute
			const targetId = $(this).attr('href').split('#')[1];
			const target = $('#' + targetId);

			if (target.length) {
				// Calculate the position with the appropriate offset
				const targetPosition = target.offset().top - scrollOffset;

				// Animate scrolling to the target position
				$('html, body').animate({
					scrollTop: targetPosition
				}, 1000); // Duration: 1000ms (1 second)
			}
		}
		// If the link points to a different page, let the browser handle navigation
	});
});

$(document).ready(function() {
	// Define scroll offsets for desktop and mobile
	const desktopOffset = 310;
	const mobileOffset = 200;

	// Determine the appropriate offset based on the screen width
	const scrollOffset = window.innerWidth <= 768 ? mobileOffset : desktopOffset;

	// Check if there is a hash in the URL (i.e., an ID to scroll to)
	const hash = window.location.hash;

	if (hash) {
		const target = $(hash);

		if (target.length) {
			// Scroll to the position with the appropriate offset
			$('html, body').animate({
				scrollTop: target.offset().top - scrollOffset
			}, 1000); // Duration: 1000ms (1 second)
		}
	}
});




//Script na pridanie nezlomnych medzier
document.addEventListener("DOMContentLoaded", function() {
	// Check if the language is not Hungarian (lang="hu")
	if (document.documentElement.lang === "hu") {
		return; // Stop the script from running for Hungarian language pages
	}

	// Comprehensive list of Slovak, csech, and Hungarian prepositions
	const prepositionsAndRelatedTerms = [
		// Slovak Prepositions and Related Terms
		"a", "aj", "ak", "ako", "ale", "až", "bez", "cez", "do", "ho", "i", "k", "ku",
		"medzi", "na", "nad", "naproti", "napriek", "než", "o", "od", "okolo",
		"po", "pod", "popri", "pred", "pre", "pri", "proti", "s", "so", "spolu",
		"u", "v", "vo", "vďaka", "vedľa", "versus", "voči", "z", "za", "zo",
		"oproti", "smerom", "kvôli", "mimo", "popod", "prostred", "okrem",
		"sú", "aj", "iba", "ani", "či", "hoci", "kým", "len", "veď", "hneď", "teraz",
		"často", "potom", "už", "dokonca", "napokon", "hoci", "predtým", "keďže",
		"kdekoľvek", "nielen", "ešte", "kým", "kýmkoľvek", "kde",

		// csech Prepositions and Related Terms
		"a", "anebo", "ani", "až", "bez", "během", "blízko", "do", "ho", "i", "co",
		"jako", "k", "ke", "kvůli", "mezi", "mimo", "na", "nad", "naproti",
		"nebo", "než", "o", "ob", "od", "okolo", "poblíž", "pod", "podél",
		"podle", "před", "přes", "pro", "proti", "s", "se", "skrze", "spolu",
		"u", "uprostřed", "v", "ve", "vedle", "versus", "včetně", "vůči",
		"za", "ze", "zpoza", "jsou", "pokud", "ač", "jen", "také", "vždyť", "naprosto",
		"okamžitě", "následně", "častěji", "občas", "dokonce", "pouze", "třebaže",
		"předtím", "že", "ačkoliv", "poněvadž", "kdekoliv", "aniž", "dokud", "dokudkoliv","kteří","který",

		// Hungarian Prepositions and Related Terms
		"alá", "alatt", "által", "át", "ellen", "elé", "elő", "előtt", "felé",
		"fenn", "fent", "fölé", "fölött", "hátra", "hozzá", "ide", "iránt",
		"keresztül", "kívül", "közé", "között", "közül", "mellé", "mellett",
		"mögé", "mögött", "nélkül", "neki", "oda", "rá", "re", "róla",
		"szerint", "szembe", "szemben", "széjjel", "szét", "távol", "túl",
		"után", "végig", "vissza", "össze", "körül", "belül", "mögött",
		"alapján", "ellenére", "egyenesen", "kivéve", "mentén", "csak", "mert",
		"vagy", "amíg", "miatt", "pedig", "tehát", "azonban", "azonnal", "majd",
		"már", "még", "míg", "mindig", "soha", "hirtelen", "mintha", "amint",
		"bár", "hol", "bárhol", "mégis"
	];

	const regex = new RegExp(`\\b(${prepositionsAndRelatedTerms.join("|")})\\s`, "gi");

	// Function to process text nodes only
	function processTextNodes(element) {
		element.childNodes.forEach(node => {
			if (node.nodeType === Node.TEXT_NODE) {
				// Only replace text content, not tags
				node.textContent = node.textContent.replace(regex, "$1\u00A0");
			}
		});
	}

	// Select specific elements to modify
	document.querySelectorAll("p, .text-content, h1, h2, h3, h4, h5, h6").forEach(element => {
		processTextNodes(element);
	});
});

function copyAllReviews() {
	// Select the target container where all reviews will be consolidated
	const targetContainer = document.querySelector('#all_reviews #review-container');

	if (!targetContainer) {
		return;
	}

	// Select all sections with the class "archive_reviews_section"
	const reviewSections = document.querySelectorAll('.archive_reviews_section');

	reviewSections.forEach(section => {
		// Select all review items within the current section
		const reviewItems = section.querySelectorAll('.review_item');

		reviewItems.forEach(item => {
			// Clone each review item and append it to the target container
			const clonedItem = item.cloneNode(true);


			targetContainer.appendChild(clonedItem);
		});
	});

}

copyAllReviews();
// Example JSON translations object


document.addEventListener('DOMContentLoaded', function () {
	// Only run this on Recharge customer portal pages
	if (window.location.pathname.includes('/tools/recurring/portal/')) {
		const params = new URLSearchParams(window.location.search);
		if (params.get('scrollToBanner') === '1') {
			const scrollToTarget = () => {
				const el = document.getElementById('rechargeSubsBanner');
				if (el) {
					el.scrollIntoView({ behavior: 'smooth' });
				} else {
					// Retry if it's not yet rendered
					setTimeout(scrollToTarget, 300);
				}
			};
			scrollToTarget();
		}
	}
});


window.deliveryEstimation = function (options = {}) {
  const locale = options.locale || "cs-CZ";
  const timeZone = options.timeZone || "Europe/Prague";
  const cutoffTime = options.cutoffTime || "00:00";
  const fixedNumberOfWorkingDays = options.fixedNumberOfWorkingDays || 0;
  const debugTime = options.debugTime || null;

  function getShopDate(date = null) {
    if (debugTime) return new Date(debugTime);
    const baseDate = date || new Date();

    const parts = new Intl.DateTimeFormat(locale, {
      timeZone: timeZone,
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    }).formatToParts(baseDate);

    const data = {};
    parts.forEach((p) => {
      if (p.type !== "literal") data[p.type] = parseInt(p.value, 10);
    });

    return new Date(data.year, data.month - 1, data.day, data.hour, data.minute, data.second);
  }

  function formatDate(date) {
    const formatter = new Intl.DateTimeFormat(locale, {
      day: "2-digit",
      month: "2-digit",
      timeZone: timeZone,
    });
    return formatter.format(date);
  }

  function getIsWeekend(date) {
    const day = date.getDay();
    return day === 0 || day === 6;
  }

  function getIsAfterCutoffTime(cutoffTime) {
    const now = getShopDate();
    const cutoffDate = new Date(now);
    const [h, m] = cutoffTime.split(":").map(Number);
    cutoffDate.setHours(h, m, 0, 0);
    return now >= cutoffDate;
  }

  function getEasterDateByYear(year) {
    const f = Math.floor;
    const a = year % 19;
    const b = f(year / 100);
    const c = year % 100;
    const d = f(b / 4);
    const e = b % 4;
    const g = f((8 * b + 13) / 25);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = f(c / 4);
    const k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7;
    const m = f((a + 11 * h + 22 * l) / 451);
    const month = f((h + l - 7 * m + 114) / 31);
    const day = ((h + l - 7 * m + 114) % 31) + 1;
    const easterDate = new Date(year, month - 1, day);
    const shopDate = getShopDate();
    easterDate.setHours(shopDate.getHours(), shopDate.getMinutes(), shopDate.getSeconds());
    return easterDate;
  }

  function getIsStateHoliday(date) {
    // Contains list of holidays shared between all countries
    let holidayList = [
      { day: 1, month: 1 }, // New Year’s Day
      { day: 1, month: 5 }, // Labour Day
      { day: 25, month: 12 }, // Christmas Day
      { day: 26, month: 12 }, // Second Day of Christmas / St. Stephen’s Day
    ];

    // Calculate dynamic holiday dates: Good Friday, Easter Sunday, Easter Monday
    const easterDate = getEasterDateByYear(date.getFullYear());

    const goodFriday = new Date(easterDate);
    goodFriday.setDate(easterDate.getDate() - 2);

    const easterMonday = new Date(easterDate);
    easterMonday.setDate(easterDate.getDate() + 1);

    holidayList.push(
      {
        day: goodFriday.getDate(),
        month: goodFriday.getMonth() + 1,
      },
      {
        day: easterDate.getDate(),
        month: easterDate.getMonth() + 1,
      },
      {
        day: easterMonday.getDate(),
        month: easterMonday.getMonth() + 1,
      },
    );

    switch (Shopify.locale) {
      case "cs":
        const czechHolidays = [
          { day: 8, month: 5 }, // Victory Day
          { day: 5, month: 7 }, // Saints Cyril and Methodius Day
          { day: 6, month: 7 }, // Jan Hus Day
          { day: 28, month: 9 }, // Statehood Day
          { day: 28, month: 10 }, // Independent Czechoslovak State Day
          { day: 17, month: 11 }, // Struggle for Freedom and Democracy Day
          { day: 24, month: 12 }, // Christmas Eve
        ];
        holidayList = [...holidayList, ...czechHolidays];
        break;
      case "sk":
        const slovakHolidays = [
          { day: 6, month: 1 }, // Epiphany
          { day: 8, month: 5 }, // Victory Day
          { day: 5, month: 7 }, // Saints Cyril and Methodius Day
          { day: 29, month: 8 }, // Slovak National Uprising Anniversary
          { day: 1, month: 9 }, // Constitution Day
          { day: 15, month: 9 }, // Seven Sorrows of the Virgin Mary
          { day: 1, month: 11 }, // All Saints’ Day
          { day: 17, month: 11 }, // Struggle for Freedom and Democracy Day
          { day: 24, month: 12 }, // Christmas Eve
        ];
        holidayList = [...holidayList, ...slovakHolidays];
        break;
      case "hu":
        const hungarianHolidays = [
          { day: 15, month: 3 }, // Revolution and Independence Day (1848)
          { day: 20, month: 8 }, // St. Stephen's Day (Foundation of Hungary)
          { day: 23, month: 10 }, // Revolution of 1956 Memorial Day
        ];
        holidayList = [...holidayList, ...hungarianHolidays];
        break;
    }
    return holidayList.some((item) => item.day === date.getDate() && item.month - 1 === date.getMonth());
  }

  function getDeliveryDateByNumberOfWorkingDays(numberOfWorkingDays) {
    const now = getShopDate();
    const result = new Date(now);

    for (let addedDays = 0; addedDays < numberOfWorkingDays; ) {
      result.setDate(result.getDate() + 1);
      const isWeekend = getIsWeekend(result);
      const isStateHoliday = getIsStateHoliday(result);
      if (!isWeekend && !isStateHoliday) addedDays++;
    }

    return result;
  }

  function getDeliveryDateISO() {
    let numberOfWorkingDays;

    if (fixedNumberOfWorkingDays > 0) {
      numberOfWorkingDays = fixedNumberOfWorkingDays;
    } else {
      const now = getShopDate();
      const isNowWeekend = getIsWeekend(now);
      const isNowStateHoliday = getIsStateHoliday(now);

      if (isNowWeekend || isNowStateHoliday) {
        numberOfWorkingDays = 2;
      } else if (getIsAfterCutoffTime(cutoffTime)) {
        numberOfWorkingDays = 2;
      } else {
        numberOfWorkingDays = 1;
      }
    }

    const deliveryDate = getDeliveryDateByNumberOfWorkingDays(numberOfWorkingDays);
    const year = deliveryDate.getFullYear();
    const month = String(deliveryDate.getMonth() + 1).padStart(2, "0");
    const day = String(deliveryDate.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  return {
    getShopDate,
    formatDate,
    getIsWeekend,
    getIsAfterCutoffTime,
    getEasterDateByYear,
    getIsStateHoliday,
    getDeliveryDateByNumberOfWorkingDays,
    getDeliveryDateISO,
  };
};


if (!customElements.get("delivery-estimation")) {
  class DeliveryEstimation extends HTMLElement {
    constructor() {
      super();

      this.locale = "cs-CZ";
      this.timeZone = "Europe/Prague";
      this.cutoffTime = "00:00";
      this.text = "{date}";
      this.fixedNumberOfWorkingDays = 0;
      this.interval = null;
      this.intervalCallbackBound = this.intervalCallback.bind(this);
      this.intervalTimeout = 60000; // 1 minute

      // Debug options
      this.debugTime = null;
    }

    expectDeliveryInWorkingDays(numberOfWorkingDays) {
      const deliveryDate = this.deliveryEstimationHook.getDeliveryDateByNumberOfWorkingDays(numberOfWorkingDays);
      const formattedDate = this.deliveryEstimationHook.formatDate(deliveryDate);
      this.innerText = this.text.replace("{date}", formattedDate);
    }

    intervalCallback() {
      const isAfterCutoffTime = this.deliveryEstimationHook.getIsAfterCutoffTime(this.cutoffTime);

      if (isAfterCutoffTime) {
        this.expectDeliveryInWorkingDays(2);
      } else {
        this.expectDeliveryInWorkingDays(1);
      }
    }

    setupDebug() {
      const urlParams = new URLSearchParams(window.location.search);
      const debugTime = urlParams.get("debug_time");
      if (!debugTime) return;
      this.debugTime = debugTime;
      console.warn("[Delivery estimation] Shop time set to:", new Date(debugTime));
    }

    connectedCallback() {
      this.cutoffTime = this.getAttribute("data-cutoff-time");
      this.text = this.getAttribute("data-text");

      if (!this.text) {
        console.error("data-text not found");
        return;
      }

      if (this.hasAttribute("data-locale")) {
        this.locale = this.getAttribute("data-locale");
      }

      if (this.hasAttribute("data-time-zone")) {
        this.timeZone = this.getAttribute("data-time-zone");
      }

      if (this.hasAttribute("data-interval-timeout")) {
        this.intervalTimeout = parseInt(this.getAttribute("data-interval-timeout"));
      }

      if (this.hasAttribute("data-fixed-number-days")) {
        this.fixedNumberOfWorkingDays = parseInt(this.getAttribute("data-fixed-number-days"));
      }

      this.setupDebug();

      this.deliveryEstimationHook = window.deliveryEstimation({
        locale: this.locale,
        timeZone: this.timeZone,
        cutoffTime: this.cutoffTime,
        fixedNumberOfWorkingDays: this.fixedNumberOfWorkingDays,
        debugTime: this.debugTime,
      });

      if (this.fixedNumberOfWorkingDays > 0) {
        this.expectDeliveryInWorkingDays(this.fixedNumberOfWorkingDays);
        return;
      }

      const now = this.deliveryEstimationHook.getShopDate();
      const isNowWeekend = this.deliveryEstimationHook.getIsWeekend(now);
      const isNowStateHoliday = this.deliveryEstimationHook.getIsStateHoliday(now);

      if (isNowWeekend || isNowStateHoliday) {
        this.expectDeliveryInWorkingDays(2);
        return;
      }

      // Run interval callback on initial render
      this.intervalCallback();
      this.interval = setInterval(this.intervalCallbackBound, this.intervalTimeout);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
    }
  }

  customElements.define("delivery-estimation", DeliveryEstimation);
}